import clsx from 'clsx'
import { useRouter } from 'next/router'
import React from 'react'

import { Text } from '@wartek-id/text'

import TabbedNav from 'components/Topic/TabbedNav'

import type { TabbedNavItem } from 'typings/microlearning'

interface TopicHeaderProps {
  title: string
  shouldShowTab: boolean
  shouldShowInfo?: boolean
}

const TopicHeader = ({
  title,
  shouldShowTab,
  shouldShowInfo = true,
}: TopicHeaderProps) => {
  const { pathname, query } = useRouter()

  const baseHref = `/topik?topik=${query.topik}`
  const referensiHref = `/topik/referensi?topik=${query.topik}`

  const navItems = [
    {
      name: 'pelatihan',
      label: 'Pelatihan',
      href: baseHref,
    },
    {
      name: 'referensi',
      label: 'Pengayaan',
      href: referensiHref,
    },
    ,
  ] as TabbedNavItem[]

  let activeMenu = 'pelatihan'
  if (/referensi/.test(pathname)) activeMenu = 'referensi'

  const flagShowTab = shouldShowTab

  return (
    <>
      {shouldShowInfo && (
        <Text
          className={clsx(
            'px-4 pb-3 bg-white',
            !flagShowTab && 'shadow-header'
          )}
          variant="heading-lg"
        >
          {title}
        </Text>
      )}
      {flagShowTab && (
        <TabbedNav
          activeMenu={activeMenu}
          navItems={navItems}
          absolutePosition
          className="relative pt-3"
        />
      )}
    </>
  )
}

export default TopicHeader
